import {
  getAXRouterIntegrationContract,
} from './AXRouterIntegrationContract';

export type AXRuntimeDecision =
  | 'allow'
  | 'redirect'
  | 'block';

export interface AXRuntimeDecisionResult {
  readonly decision: AXRuntimeDecision;
  readonly governor: string;
  readonly reason: string;
  readonly evaluatedAt: string;
}

export function evaluateAXRuntimeDecision():
AXRuntimeDecisionResult {

  const contract =
    getAXRouterIntegrationContract();

  let decision: AXRuntimeDecision = 'allow';
  let reason = 'AX runtime verified.';

  if (contract.status === 'block') {
    decision = 'block';
    reason = 'AX runtime verification failed.';
  }

  return Object.freeze({
    decision,
    governor: contract.governor,
    reason,
    evaluatedAt: contract.generatedAt,
  });
}
